/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useEffect } from 'react';
import { useNavigate } from '@/hooks/use-navigate';
import { routes } from '@/route-paths';
import { PAYPAL_CANCELLED_MESSAGE, clearPaypalCorrelation } from '../lib/paypal-session';

export default function CybersourcePaypalCancelled() {
    const navigate = useNavigate();

    useEffect(() => {
        clearPaypalCorrelation();
        if (window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: PAYPAL_CANCELLED_MESSAGE }, window.location.origin);
            const closeTimer = setTimeout(() => window.close(), 300);
            return () => clearTimeout(closeTimer);
        }

        const returnTimer = setTimeout(() => {
            void navigate({ pathname: routes.checkout, search: '?payment=paypal' }, { replace: true });
        }, 300);
        return () => clearTimeout(returnTimer);
    }, [navigate]);

    return (
        <div className="flex min-h-[40vh] items-center justify-center p-8">
            <p className="text-sm text-muted-foreground" role="status">
                PayPal was cancelled — returning to checkout…
            </p>
        </div>
    );
}
